/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import {
  showAnnouncement,
  IsPermisionOidRequired,
  showUser,
} from "../../../../redux/actions";
import DataGrid, {
  Column,
  Paging,
  Selection,
  FilterRow,
} from "devextreme-react/data-grid";
import {
  responseAnnouncement,
  responseMiddleware,
  responseUser,
} from "../../../../redux/reducers";
import { axios } from "../../../../common";
import { useAuth } from "../../../../contexts/auth";
import AnnouncementTableList from "./AnnouncementTable";
import { useScreenSize } from "../../../../utils/media-query";
import UsingIntl from "../../../../services/using_intl";
import PopupConfig from "../../../../common/popup";

export default function AnnouncementPage() {
  let history = useHistory();
  let dataGrid = useRef(null);
  const [selectedItemKeysPopup, setSelectedItemKeysPopup] = useState([]);

  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  const [popupPushAnnouncementConfig, setPopupPushAnnouncementConfig] =
    useState({
      popupVisible: false,
      positionOf: "",
      createdAt: Date.now(),
      data: {},
    });
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { announcement } = useSelector(responseAnnouncement);
  const { isXSmall, isSmall } = useScreenSize();
  const { middleware, loading } = useSelector(responseMiddleware);
  const { user: userList } = useSelector(responseUser);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showAnnouncement());
      dispatch(showUser());
    }
  }, [middleware]);

  const handleOpenSendAnnouncementPopup = (value) => {
    setPopupPushAnnouncementConfig({
      data: value,
      positionOf: {
        my: "center center",
        at: "center center",
      },
      popupVisible: true,
    });
  };

  const handleCloseSendAnnouncementPopup = () => {
    setPopupPushAnnouncementConfig({
      popupVisible: false,
    });
  };

  const handleSelectionPopupChanged = ({ selectedRowKeys }) => {
    const userOid = selectedRowKeys.map((rowKey) => {
      const data = { Oid: rowKey._value };
      return data;
    });
    setSelectedItemKeysPopup(userOid);
  };

  const handlePublishAnnouncement = async () => {
    const announcement = popupPushAnnouncementConfig.data;
    const payload = {
      AnnouncementOid: announcement.Oid,
      IsPublish: true,
      PublishedBy: user.UserName,
      User: selectedItemKeysPopup,
    };
    const { data } = await axios.put("Announcement", payload);
    if (!data) {
      notify("Thêm mới thất bại", "error", 2000);
      return;
    }
    notify("Thêm mới thành công", "success", 2000);
    dataGrid.current.instance.refresh();
  };

  const renderPushAnnouncementPopup = () => {
    return (
      <Popup
        visible={popupPushAnnouncementConfig.popupVisible}
        onHiding={handleCloseSendAnnouncementPopup}
        title={formatMessage("SendAnnouncementTitle")}
        borderRadius={10}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        closeOnOutsideClick={true}
      >
        <ScrollView width="100%" height="100%">
          <DataGrid
            id="gridContainer2"
            dataSource={userList}
            keyExpr="Oid"
            showBorders={true}
            // selectedRowKeys={selectedItemKeysPopup}
            onSelectionChanged={handleSelectionPopupChanged}
          >
            <FilterRow visible={true} />
            <Paging enabled={true} />
            <Selection
              mode="multiple"
              selectAllMode="page"
              showCheckBoxesMode="always"
            />
            <Column dataField="UserName" caption={formatMessage("Username")} />
            <Column
              dataField="Employee.FullName"
              caption={formatMessage("FullName")}
            />
            <Column
              dataField="Employee.Department.DepartmentName"
              caption={formatMessage("Department")}
              allowEditing={false}
            />
            <Column
              dataField="Employee.Position.PositionName"
              caption={formatMessage("Position")}
              allowEditing={false}
            />
          </DataGrid>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handlePublishAnnouncement}
          options={{
            icon: "save",
            type: "primary",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Close"),
          }}
        />
      </Popup>
    );
  };
  function createMarkup() {
    return {
      __html: popupConfig.data.Message,
    };
  }
  const renderActions = ({ data }) => {
    return (
      <div>
        {middleware && middleware.WriteState && (
          <Button
            type="default"
            stylingMode="outlined"
            text={formatMessage("BtnSend")}
            icon="event"
            className="button-rounded mr-2"
            onClick={() => {
              const newData = {
                Oid: data.Oid._value,
                PublishedBy: user.UserName,
                IsPublish: true,
              };
              handleOpenSendAnnouncementPopup(newData);
            }}
          />
        )}
        <Button
          type="default"
          stylingMode="outlined"
          text={formatMessage("BtnDetail")}
          icon="detailslayout"
          className="button-rounded mr-2"
          onClick={() => {
            handleOpenPopup(data);
          }}
        />
      </div>
    );
  };

  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={popupConfig.data.Subject}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <ScrollView width="100%" height="100%">
          {/* Render with all key in object */}
          <div className="form-readonly">
            <div dangerouslySetInnerHTML={createMarkup()} />
          </div>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Close"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("Announcement")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/home" className={"breadcrumb-item"}>
            {formatMessage("Default")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("Announcement")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}
          {popupPushAnnouncementConfig.popupVisible &&
            renderPushAnnouncementPopup()}

          <AnnouncementTableList
            dataGrid={dataGrid}
            dataSource={announcement}
            middleware={middleware}
            renderActions={renderActions}
          />
        </div>
      </div>
    </div>
  );
}
